import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Chip,
  Stack,
  Typography
} from '@mui/material'
import React from 'react'

import Icon from 'components/Icon'
import { ServiceTagLabelSectionListItem } from 'components/services/create/target-selection/ServiceTagLabelSectionListItem'
import { Client } from 'types/api/attacks/client'
import { AutocompleteSearchOption } from 'types/forms'

export const ServiceTagLabelSection: React.FC<{
  label: string
  options: AutocompleteSearchOption[]
  selectedOptions: AutocompleteSearchOption[]
  unhealthyClients: Client[]
  handleSelectOption(e, option): void
}> = ({
  label,
  options,
  selectedOptions,
  handleSelectOption,
  unhealthyClients = []
}) => {
  const selectedOptionLabels = selectedOptions.map(
    (selectedOption) => selectedOption.label
  )

  const unhealthyLabels =
    unhealthyClients.length < 1
      ? []
      : options.filter((label) => {
          return (
            unhealthyClients.filter(
              (c) => c.tags[label.params?.key] === label.params?.value
            ).length > 0
          )
        })

  const unhealthyLabelMap: Record<string, boolean> = Object.fromEntries(
    unhealthyLabels.map((l) => [`${l.params?.key}:${l.params?.value}`, true])
  )

  return (
    <Accordion
      disableGutters
      data-test-target-param-section={label}
      sx={{ padding: 1 }}
    >
      <AccordionSummary
        data-test-target-param-section-summary={label}
        expandIcon={<Icon icon="solidCaretDown" />}
      >
        <Stack direction="row" gap={1}>
          <Typography color="text.secondary">{label}</Typography>
          <Chip
            label={
              <Typography fontFamily="monospace" variant="caption">
                {selectedOptions.length > 0
                  ? `${selectedOptions.length} of ${options.length} selected`
                  : options.length}
              </Typography>
            }
            size="small"
          />
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <Stack direction="row" gap={1} sx={{ flexWrap: 'wrap' }}>
          {options.map((option) => (
            <ServiceTagLabelSectionListItem
              key={`${label}-${option.label}`}
              handleSelectOption={handleSelectOption}
              isSelected={selectedOptionLabels.includes(option.label)}
              isUnhealthy={Boolean(
                unhealthyLabelMap[`${option.section}:${option.params?.value}`]
              )}
              option={option}
            />
          ))}
        </Stack>
      </AccordionDetails>
    </Accordion>
  )
}
